import type { MessageKey } from "./ru"

export const swMessages = {
  "common.loading": "Inapakia...",
  "common.error": "Hitilafu",
  "common.back": "Rudi",
  "common.next": "Endelea",
  "common.search": "Tafuta",
  "auth.loginErrorTitle": "Hitilafu ya kuingia",
  "auth.openViaTelegram": "Fungua programu kupitia Telegram",
  "auth.telegramRequired": "Programu lazima ifunguliwe kupitia Telegram",
  "auth.authorizationError": "Hitilafu ya uthibitishaji",
  "device.rotatePortrait": "Geuza kifaa kiwe wima",
  "country.brazil": "Brazili",
  "country.vietnam": "Vietnam",
  "country.egypt": "Misri",
  "country.india": "India",
  "country.indonesia": "Indonesia",
  "country.iran": "Iran",
  "country.spain": "Uhispania",
  "country.italy": "Italia",
  "country.kazakhstan": "Kazakhstan",
  "country.colombia": "Kolombia",
  "country.malaysia": "Malaysia",
  "country.mexico": "Meksiko",
  "country.nigeria": "Nigeria",
  "country.pakistan": "Pakistan",
  "country.russia": "Urusi",
  "country.usa": "Marekani",
  "country.turkey": "Uturuki",
  "country.uzbekistan": "Uzbekistan",
  "country.ukraine": "Ukraine",
  "country.philippines": "Ufilipino",
  "countrySelection.chooseCountry": "Chagua nchi",
  "countrySelection.openAria": "Chagua nchi",
  "languageSelection.chooseLanguage": "Chagua lugha",
  "commercial.direction.autotrade": "Soko la Magari",
  "commercial.direction.insurance": "Bima",
  "commercial.direction.pitstop": "Pit Stop",
  "commercial.direction.techhelp": "Msaada Barabarani",
  "commercial.searchLabel": "Utafutaji wa BeepApp",
  "commercial.cityPlaceholder": "Weka jiji",
  "commercial.emptyTitle": "Hakuna ofa leo",
  "commercial.emptyLine1": "Bado hakuna washirika hai wa BeepApp katika jiji lako",
  "commercial.emptyLine2": "Tayari tunafanya kazi ya kuwatafuta na kuwaunganisha",
  "commercial.emptyLine3": "Ofa mpya zitaonekana hapa kiotomatiki",
  "commercial.helperLine1": "Weka jiji lako ili kuona",
  "commercial.helperLine2": "ofa zinazopatikana",
  "commercial.partnerPrompt": "Unataka kuwa mshirika wa BeepApp?",
  "commercial.apply": "Tuma ombi",
  "main.admin": "Admin",
  "main.garage": "Garage",
  "main.signalSent": "Ishara imetumwa",
  "main.partnerInviteUnavailable": "Mwaliko wa ushirika haupatikani",
  "main.enterPlate": "Weka namba ya usajili",
  "main.searchError": "Hitilafu ya utafutaji",
  "main.signalSendError": "Imeshindikana kutuma ishara",
  "main.shareCardPrefix": "Kadi ya namba",
  "main.shareLinkError": "Imeshindikana kuandaa kiungo",
  "main.searchByPlateAria": "Tafuta kwa namba ya usajili",
  "main.russianPlateAria": "Namba ya usajili ya Urusi",
  "main.plateAria": "Namba ya usajili",
  "main.findPlateAria": "Tafuta namba",
  "main.loadingVehicle": "Inapakia kadi ya namba…",
  "main.leaveSignal": "Tuma ishara",
  "main.share": "Shiriki",
  "signalSelection.chooseType": "Chagua aina ya ishara",
  "signalSelection.category.attention": "Binafsi",
  "signalSelection.category.road": "Barabarani",
  "signalSelection.category.urgent": "Dharura",
  "signalSelection.chooseSignal": "Chagua ishara",
  "signalSelection.suggestOwn": "Pendekeza yako",
  "signalConfirmation.title": "Thibitisha ishara",
  "signalConfirmation.plateHeading": "Kagua namba ya usajili",
  "signalConfirmation.signalHeading": "Kagua ishara uliyochagua",
  "signalConfirmation.replyTitle": "Ruhusu jibu kupitia Telegram",
  "signalConfirmation.replyBody": "Washa hili ili mmiliki wa namba aweze\nkukuandikia Telegram. Majibu yanawezekana tu kama\nuna @username. Uamuzi wa kujibu unabaki\nkwa mmiliki wa namba.",
  "signalConfirmation.consentText": "Ninathibitisha kuwa ishara hii inaeleza\nhali halisi na si barua taka\nwala taarifa ya uongo.",
  "signalConfirmation.warning": "Baada ya kutuma, ishara\nhaiwezi kubadilishwa",
  "signalConfirmation.sending": "Inatuma…",
  "signalConfirmation.send": "Tuma",
  "partner.loadingAria": "Inapakia",
  "partner.title": "Mpango wa Ushirika",
  "partner.offerLine1": "Pata 30% ya malipo yote bila kikomo cha muda",
  "partner.offerLine2": "kutoka kwa watumiaji unaowaalika BeepApp",
  "partner.offerLine3": "kupitia Telegram Affiliate",
  "partner.connectUnavailable": "Muunganisho utapatikana baada ya Telegram Affiliate kusanidiwa.",
  "partner.connectTelegram": "Unganisha kwenye Telegram",
  "partner.qrAria": "Msimbo wa QR wa kiungo cha ushirika",
  "partner.download": "Pakua",
  "partner.promoHeading": "Tengeneza promo code binafsi",
  "partner.promoHelperLine1": "Promo code huongeza mwaka mmoja wa usajili",
  "partner.promoHelperLine2": "na husaidia kuvutia watumiaji",
  "partner.promoAria": "Promo code",
  "partner.affiliateHeading": "Kiungo chako cha ushirika",
  "partner.affiliateHelper": "Hifadhi kiungo ili kutengeneza QR binafsi",
  "partner.affiliateAria": "Kiungo cha ushirika",
  "partner.qrNoteLine1": "QR inaweza kuwekwa kwenye gari lako,",
  "partner.qrNoteLine2": "mitandao ya kijamii na vifaa vya matangazo",
  "partner.save": "Hifadhi",
  "partner.reset": "Weka upya",
  "partner.resetConfirm": "Weka upya kiungo cha ushirika kilichohifadhiwa? Promo code itabaki yako.",
  "partner.promoFormatError": "Promo code lazima iwe na herufi 4 hadi 15.",
  "partner.affiliateHostError": "Viungo vya t.me au telegram.me pekee vinaruhusiwa.",
  "partner.affiliatePathError": "Kiungo hakina njia ya Telegram.",
  "partner.affiliateFormatError": "Kiungo cha ushirika si sahihi.",
  "partner.loadError": "Hitilafu ya kupakia",
  "partner.checkInputError": "Kagua taarifa ulizoingiza",
  "garageActivation.promoInvalid": "Promo code si sahihi",
  "garageActivation.plateOccupied": "Namba hii tayari imeunganishwa",
  "garageActivation.activateError": "Imeshindikana kuwasha Garage",
  "garageEntry.loadJournalError": "Imeshindikana kupakia logbook",
  "garageEntry.loadStatusesError": "Imeshindikana kupakia status",
  "garageEntry.activationSuccess": "Garage imewashwa kikamilifu",
  "garageEntry.plateAttached": "Namba imeunganishwa",
  "garageEntry.attachError": "Imeshindikana kuunganisha namba",
  "garageEntry.activationNote": "Washa Garage yako",
  "garageSheet.activationTitle": "Kuwasha Garage",
  "garageSheet.plateHelper": "Weka namba ya usajili ya gari",
  "garageSheet.promoHelper": "Una promo code?",
  "garageSheet.cleanBonusLine1": "Baada ya kuwasha utakuwa na saa 1",
  "garageSheet.cleanBonusLine2": "ya “Clean Start” bila malipo",
  "garageSheet.activationFor": "Uanzishaji kwa",
  "garageSheet.cost": "Gharama",
  "garageSheet.ownerConsentLine1": "Ninathibitisha kuwa mimi ni mmiliki",
  "garageSheet.ownerConsentLine2": "wa gari lenye namba",
  "garageSheet.ownerConsentLine3": "iliyotajwa.",
  "garageSheet.processing": "Inachakata...",
  "garageSheet.attach": "Unganisha",
  "garageSheet.pay": "Lipa",
  "garageLifecycle.cleanTitle": "Clean Start",
  "garageLifecycle.deactivateTitle": "Kuzima Garage",
  "garageLifecycle.cleanWarningLine1": "Historia ya namba itafutwa",
  "garageLifecycle.cleanWarningLine2": "bila uwezekano wa kuirejesha!",
  "garageLifecycle.deactivateWarningLine1": "Baada ya kuzima, ufikiaji wa vipengele",
  "garageLifecycle.deactivateWarningLine2": "hai vya Garage utaisha",
  "garageLifecycle.willBeDeleted": "VITAFUTWA",
  "garageLifecycle.cleanRemovedLine1": "• Rekodi zote za Logbook",
  "garageLifecycle.cleanRemovedLine2": "• Historia ya ishara zilizopokelewa",
  "garageLifecycle.cleanRemovedLine3": "• Kaunta za ishara za umma",
  "garageLifecycle.cleanRemovedLine4": "  kwenye kadi ya namba",
  "garageLifecycle.willRemain": "VITABAKI",
  "garageLifecycle.cleanPreservedLine1": "• Muunganisho wa namba na Garage",
  "garageLifecycle.cleanPreservedLine2": "• Muda wa uanzishaji uliobaki",
  "garageLifecycle.cleanPreservedLine3": "• Status ya namba iliyochaguliwa",
  "garageLifecycle.cleanPreservedLine4": "• Jumla ya mara kadi ya namba ilipotazamwa",
  "garageLifecycle.freeFirstHour": "Bila malipo ndani ya saa ya kwanza",
  "garageLifecycle.willBecomeUnavailable": "HAVITAPATIKANA",
  "garageLifecycle.deactivateRemovedLine1": "• Logbook",
  "garageLifecycle.deactivateRemovedLine2": "• Kuchagua na kutumia status ya namba",
  "garageLifecycle.deactivateRemovedLine3": "• Utaondoka AutoClan kiotomatiki",
  "garageLifecycle.deactivateRemovedLine4": "• Soko la Magari",
  "garageLifecycle.deactivateRemovedLine5": "• Bima",
  "garageLifecycle.deactivateRemovedLine6": "• Pit Stop",
  "garageLifecycle.deactivateRemovedLine7": "• Msaada Barabarani",
  "garageLifecycle.deactivateRemovedLine8": "• Namba itaondolewa kwenye Garage",
  "garageLifecycle.willRemainAvailable": "VITABAKI KUPATIKANA",
  "garageLifecycle.deactivatePreservedLine1": "• Companion",
  "garageLifecycle.deactivatePreservedLine2": "• Dispatcher",
  "garageLifecycle.deactivatePreservedLine3": "• Utafutaji wa namba na kutazama",
  "garageLifecycle.deactivatePreservedLine4": "  kadi ya gari ya umma",
  "garageLifecycle.deactivatePreservedLine5": "• Uwezo wa kuwasha tena",
  "garageLifecycle.deactivatePreservedLine6": "  Garage wakati wowote",
  "garageLifecycle.cleanConsentLine1": "Ninakubali kufuta",
  "garageLifecycle.cleanConsentLine2": "historia yote ya namba hii",
  "garageLifecycle.cleanConsentLine3": "bila uwezekano wa kuirejesha.",
  "garageLifecycle.deactivateConsentLine1": "Ninathibitisha kuzima na",
  "garageLifecycle.deactivateConsentLine2": "kusitisha ufikiaji wa vipengele vyote",
  "garageLifecycle.deactivateConsentLine3": "hai vya Garage.",
  "garageLifecycle.clean": "Futa",
  "garageLifecycle.deactivate": "Zima",
} satisfies Record<MessageKey, string>
